/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockOutboundDetailResVo } from './StockOutboundDetailResVo';
import {
    StockOutboundDetailResVoFromJSON,
    StockOutboundDetailResVoFromJSONTyped,
    StockOutboundDetailResVoToJSON,
    StockOutboundDetailResVoToJSONTyped,
} from './StockOutboundDetailResVo';

/**
 * 
 * @export
 * @interface ResponseListStockOutboundDetailResVo
 */
export interface ResponseListStockOutboundDetailResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListStockOutboundDetailResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListStockOutboundDetailResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<StockOutboundDetailResVo>}
     * @memberof ResponseListStockOutboundDetailResVo
     */
    data?: Array<StockOutboundDetailResVo>;
}

/**
 * Check if a given object implements the ResponseListStockOutboundDetailResVo interface.
 */
export function instanceOfResponseListStockOutboundDetailResVo(value: object): value is ResponseListStockOutboundDetailResVo {
    return true;
}

export function ResponseListStockOutboundDetailResVoFromJSON(json: any): ResponseListStockOutboundDetailResVo {
    return ResponseListStockOutboundDetailResVoFromJSONTyped(json, false);
}

export function ResponseListStockOutboundDetailResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListStockOutboundDetailResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StockOutboundDetailResVoFromJSON)),
    };
}

export function ResponseListStockOutboundDetailResVoToJSON(json: any): ResponseListStockOutboundDetailResVo {
    return ResponseListStockOutboundDetailResVoToJSONTyped(json, false);
}

export function ResponseListStockOutboundDetailResVoToJSONTyped(value?: ResponseListStockOutboundDetailResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StockOutboundDetailResVoToJSON)),
    };
}

